/* eslint-disable padding-line-between-statements */
/**
 * MSB Functions for TWIA, TFPA & Commercial LOBs.
 */
import { useModal } from '@jutro/components';
import _ from 'lodash';
import { MSBService } from 'gw-capability-gateway';
import TFPACoverablesUtils from "tfpa-capability-quoteandbind-residential-react/util/TFPACoverablesUtils";
import messages from './MsbInfoUtil.messages';
import TWIAJobHelper from './TWIAJobHelper';


function MSBInfoUtil(submissionVM, updateWizardData, authHeader)  {

    function shouldLaunchMSB_TWIA() {
        // Launch MSB is only valid for the 4 structureTypes below.
        const selectedStructureType = _.get(submissionVM, 'lobData.homeowners.coverables.construction.structureType_TWIA.value');
        if (!_.isUndefined(selectedStructureType) && (selectedStructureType.code === '1Family' ||
            selectedStructureType.code ==='2Family' ||
            selectedStructureType.code === 'IndividuallyTH' ||
            selectedStructureType.code == 'PublicHousing'))
            {
                return true;
            }
            else {
                return false;
            }
    }
     /**
     * US12407 - Determine if Msb Valuation is completed.
     * @param {{}} construction
     * @returns {{msbApplicablePolicy: boolean, msbRefreshPending: boolean, msbDataAvailable: boolean, msbValuationCompleted: (boolean|boolean)}|{msbApplicablePolicy: boolean, msbRefreshPending: boolean, msbDataAvailable: boolean, msbValuationCompleted: boolean}}
     */
  
    const msbStatusInfo = () => {
        // Stay on current page, if MSB Valuation is not completed.
        const yourHome = submissionVM.lobData.homeowners.coverables.yourHome.value;
        const construction = submissionVM.lobData.homeowners.coverables.construction.value;
        const baseData = submissionVM.baseData.value;
        const {
            msbValuationRefreshAvailable_TWIA: msbRefreshPending = false,
            msbDataExists_TWIA: msbDataAvailable = false
        } = construction;

        const {
            msbEligiblePolicyType_TWIA: msbApplicablePolicy = false
        } = yourHome;
        // migration status flag
        const {
            migratedPolicy_TWIA: migrated = false
        } = baseData; 

        return {
            msbRefreshPending,
            msbDataAvailable,
            msbApplicablePolicy,
            msbValuationCompleted: (!msbApplicablePolicy ? true : migrated ? true : !msbRefreshPending && msbDataAvailable)
        };
    }

    function  msbShowErrorDialog(msbInfo, translator, showAlert) {
       
        const {msbRefreshPending, msbDataAvailable, msbValuationUrlAvailable} = msbInfo;
        // PE - Unable to Launch MSB. MSB Valuation Failed. 
        // Display "Address provided was not found by MSB" message when an MSB error occurs but an MSB Valuation URL is
        // provided
        if ((!msbDataAvailable && msbValuationUrlAvailable) ) {
            showAlert({
                title: translator(messages.msbValuationFailedTitle),
                message: translator(messages.msbValuationFailedMsg),
                status: 'error',
                icon: 'mi-error-outline',
                confirmationText: 'Close'
        })
        } else if (!msbDataAvailable) {
            showAlert(
               { title: translator(messages.msbValuationFailedTitle),
                message:translator(messages.msbValuationFailedMsg),
                status: 'error',
                icon: 'mi-error-outline',
                confirmationText: 'Close'}
            )
        } else if (msbRefreshPending) {
            showAlert({
                title: translator(messages.msbRefreshRequiredTitle),
                message: translator(messages.msbRefreshRequiredMsg),
                status:'error',
                icon: 'mi-error-outline',
                confirmationText: 'Close'
        });
        }
    }

    const launchMSB = (translator, showAlert) =>{
        const {value: sub} = submissionVM;
        const jobNumber = sub.quoteID === undefined ? sub.jobID : sub.quoteID;//DE17138
        let msbLaunchPromise;
        if (sub.baseData.jobType === 'Submission') {
            msbLaunchPromise = MSBService.getMSBHoLaunchURL(sub.sessionUUID, jobNumber, authHeader);
        } else if (sub.baseData.jobType === 'Renewal') {
            msbLaunchPromise = MSBService.getMSBHoRenewalLaunchURL(sub.sessionUUID, jobNumber, authHeader);
        } else if (sub.baseData.jobType === 'PolicyChange') {
            msbLaunchPromise = MSBService.getMSBHoPolicyChangeLaunchURL(sub.sessionUUID, jobNumber, authHeader);
        }

        const msbInProgressTwia = msbLaunchPromise;
        msbLaunchPromise.then((url) => {
            submissionVM.lobData.homeowners.coverables.construction.msbValuationRefreshAvailable_TWIA.value = true;
            updateWizardData(submissionVM);
            window.open(url, '_blank');
        }).catch((err) => {
            console.error(`MSB Launch Error: ${err}`);
            //   When an error occurs attempting to Launch MSB, call the service which returns the MSB Valuation URL
            //   if provided by MSB when an MSB error occurs.  This scenario can happen when the provided address
            //   isn't found by MSB. Don't display the 1st MSB service error.  Just open the MSB Valuation URL if provided by the 2nd
            //   MSB service, or display its error.
            let forceMsbLaunchPromise;
            if (sub.baseData.jobType === 'Submission') {
                forceMsbLaunchPromise = MSBService.getForceMSBHoLaunchURL(sub.sessionUUID, jobNumber, authHeader);
            } else if (sub.baseData.jobType === 'Renewal') {
                forceMsbLaunchPromise = MSBService.getForceMSBHoRenewalLaunchURL(sub.sessionUUID, jobNumber, authHeader);
            } else if (sub.baseData.jobType === 'PolicyChange') {
                forceMsbLaunchPromise = MSBService.getForceMSBHoPolicyChangeLaunchURL(sub.sessionUUID, jobNumber, authHeader);
            }            
            const msbInProgressTwia_2 = forceMsbLaunchPromise;
            forceMsbLaunchPromise.then((url) => {
                submissionVM.lobData.homeowners.coverables.construction.msbValuationRefreshAvailable_TWIA.value = true;
                updateWizardData(submissionVM);
                window.open(url, '_blank');
            }).catch((err) => {
                console.error(`Force MSB Launch Error: ${err}`);
                msbShowErrorDialog({msbDataAvailable: false}, translator, showAlert);
            });
        });
    }

    const clearMsbFields_twia = () => {
        submissionVM.lobData.homeowners.coverables.construction.constructionType.value =undefined;
        submissionVM.lobData.homeowners.coverables.construction.yearBuilt.value = undefined;
        submissionVM.lobData.homeowners.coverables.construction.approxSquareFootage_TWIA.value = undefined;
        submissionVM.lobData.homeowners.coverables.construction.storiesNumber.value = undefined;
        submissionVM.lobData.homeowners.coverables.construction.garageType_TWIA.value = undefined;
        submissionVM.lobData.homeowners.coverables.construction.foundationType.value = undefined;
        updateWizardData(submissionVM);
    }

    /**
     * MSB Valuation - refreshMSBValuation
     */
    // DE17305
    const refreshMSBValuation = (translator, showAlert,getErrorMessages) => {
        setAllConstructionFieldsValidationTwia(false);
        //_FlowValidationService.reportErrorsAndWarnings({});

        const {value: sub} = submissionVM;
        let msbRefreshPromise

        // DE17305
        if (sub.baseData.jobType === 'Submission') {
            msbRefreshPromise = MSBService.refreshMSBValuation(sub.sessionUUID, sub.quoteID, sub, authHeader);
        }
        else if(sub.baseData.jobType === 'Renewal'){
            const validationParams = {
                skipAllValidation: false,
                validationLevel: "default",
                validationWizardStep: "DwellingConstruction"
            }

            _.set(sub, 'validationParams_TWIA', validationParams);

            msbRefreshPromise = MSBService.refreshRenewalMsbValuation(sub.sessionUUID, sub.jobID, sub, authHeader);
        } else if(sub.baseData.jobType === 'PolicyChange') {
            const validationParams = {
                skipAllValidation: false,
                validationLevel: "default",
                validationWizardStep: "DwellingConstruction"
            }

            _.set(sub, 'validationParams_TWIA', validationParams);

            msbRefreshPromise = MSBService.refreshPolicyChangeMsbValuation(sub, authHeader);
        }
        
        const msbInProgressTwia = msbRefreshPromise;

        msbRefreshPromise.then((quoteDataDTO) => {
            if (quoteDataDTO.lobData.homeowners.coverables.construction) {
                submissionVM.value = quoteDataDTO;
                getErrorMessages(submissionVM.value.errorsAndWarnings.validationIssues)
            } else {
                submissionVM.errorsAndWarnings.value = quoteDataDTO.errorsAndWarnings;
            }
            
            // DE18038
            // DE19153
            const yearBuilt = _.get(submissionVM,'lobData.homeowners.coverables.construction.yearBuilt.value');
            const origConstDate = _.get(sub, 'lobData.homeowners.coverables.construction.originalConstDate_TWIA');
            if (yearBuilt && yearBuilt !== origConstDate?.year) {
                _.set(submissionVM, 'lobData.homeowners.coverables.construction.originalConstDate_TWIA.value', {
                    year: submissionVM.lobData.homeowners.coverables.construction.yearBuilt?.value,
                    month: '00',
                    day: '01'
                });
            }

            updateWizardData(submissionVM);

        }).catch((err) => {
            console.log('Error', err);
        }).finally(() => {
           // _FlowValidationService.reportErrorsAndWarnings(submissionVm.errorsAndWarnings.value);
            setAllConstructionFieldsValidationTwia(true);
        });
    }

    const isRefreshMSBAvailable = () => {
        return _.get(submissionVM.lobData.homeowners.coverables.construction.value, 'msbValuationRefreshAvailable_TWIA', false);
    }

    const isRefreshMSBAvailable_TFPA = () => {
        const yourHomeValue = TFPACoverablesUtils.getYourHome(submissionVM);
        const isMobileHome = _.get(submissionVM, 'lobData.homeowners_tfpa.coverables.construction.constructionType.value.code') === 'MH_ext';
        // DE18870
        if (isMobileHome) {
            return false
        }

        return _.get(yourHomeValue, 'valuationRefreshAvailable_Ext'); // DE17842
    }


   /**
     * MSB Refresh Validation. Selectively disable certain fields validation to bypass DTO Validation,
     * as back-end calls needs to be invoked as some required fields are not entered by user yet.
     * @param {boolean} enable
     */
   const setAllConstructionFieldsValidationTwia =(enable = true) =>{
        if (!_.isUndefined(submissionVM.lobData.homeowners.coverables.construction)) {
            submissionVM.lobData.homeowners.coverables.construction.value.allRequiredFieldsValidation_TWIA = enable;
            updateWizardData(submissionVM);
        }
    }

    /**
     * TFPA
     */
    const loadValuationTFPA = (showAlert, translator) => {
        const msbLaunchPromise = MSBService.getValuationReviewURL(submissionVM.value, authHeader);
        const msbInProgressTfpa = msbLaunchPromise;
        msbLaunchPromise.then((redirectURL) => {
            TFPACoverablesUtils.setValuationRefresh(submissionVM, true);
            updateWizardData(submissionVM);
           window.open(redirectURL, '_blank');
        });
    };

    function getUpdatedValuationTFPA(showAlert, translator) {
        MSBService.getUpdatedValuation(submissionVM.value, authHeader).then((newMSBValue) => {
        if (newMSBValue) {
            TFPACoverablesUtils.setMSBValue(submissionVM, newMSBValue.estimatedReplacementCost);
            TFPACoverablesUtils.setActualCashValue(submissionVM, newMSBValue.actualCashValue);
            TFPACoverablesUtils.setValuationRefresh(submissionVM, false);
            updateWizardData(submissionVM);
            return true;
       
        } else {
            showAlert({
                title: translator(messages.refreshValuation),
                message: translator(messages.refreshValuationRequired),
                status:'',
                icon: 'mi-error-outline',
                confirmationText: 'Close'
            }
           );
        }
        }).catch((error) => {
           showAlert({
                title: translator(messages.valuationFailed),
                message: translator(messages.unableToRetrieveValuation),
                status:'',
                icon: 'mi-error-outline',
                confirmationText: 'Close'
            }
          );
        });
    };

    const getUrlAndOpen = ()=>{
        const myWindow = window.open();
        const urlPromise = MSBService.getReviewMSBUrl(submissionVM.value.policyNumber, authHeader);
        urlPromise.then((url) => {
          myWindow.location.href = url;
        });
      };

    const checkMSBUrlAvailability = () => {
        // check the isMSBUrlAvailable flag
        const urlPromise = MSBService.getReviewMSBUrl(submissionVM.value.policyNumber, authHeader);
        urlPromise.then((url) => {
            submissionVM.lobData.homeowners_tfpa.isMSBUrlAvailable = url.length > 0;
        });
        updateWizardData(submissionVM);
      };

      /**
       * Commercial Lines...
       */

    const getMSBCommercialLoginUrl = () => {
        MSBService.getMSBCommercialLoginURL(authHeader).then((data) => {
            window.open(data, '_blank');
        }).catch((error) => {
            console.error(`Encountered the following error attempting to fetch msb commercial login url from PolicyCenter:${error}`);
        });
    };
    
    const openMSBCommercialWebsite = (url) => {
        const win = window.open(url, '_blank');
        win.focus();
    };

    return {
        msbStatusInfo,
        msbShowErrorDialog,
        launchMSB,
        refreshMSBValuation,
        isRefreshMSBAvailable,
        isRefreshMSBAvailable_TFPA,
        setAllConstructionFieldsValidationTwia,
        loadValuationTFPA,
        getUpdatedValuationTFPA,
        getUrlAndOpen,
        checkMSBUrlAvailability,
        getMSBCommercialLoginUrl,
        openMSBCommercialWebsite,
        clearMsbFields_twia,
        shouldLaunchMSB_TWIA
    }
}

export default  MSBInfoUtil;